import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HashRouter, Routes, Route } from "react-router-dom";
import PaginaNaoEncontrada from "../components/paginaNaoEncontrada";
import StaticContent from "../components/static";
import EspelhoProducao from "../pages/espelhoProducao";
import EspelhoProducaoImprimir from "../pages/espelhoProducao/imprimir";
import ExtratoRepasseExterno from "../pages/extratoRepasseExterno";
import ExtratoRepasseExternoImpressao from "../pages/extratoRepasseExterno/imprimir";
import ExtratoRepasse from "../pages/extratoRepasse";
import ExtratoRepasseImpressao from "../pages/extratoRepasse/imprimir";
import ImpostoRenda from "../pages/ImpostoRenda";
import Login from "../pages/login";
import PreCadastro from "../pages/preCadastro";
import PrevisaoProducao from "../pages/previsaoProducao";
import RecuperarSenha from "../pages/recuperarSenha";
import RegistroBiometrico from "../pages/registroBiometrico";
import routes from "./routes.path";
import AmbienteDev from "../pages/ambienteDev";
import { useDispatch } from "react-redux";
import recuperarSenhaActions from "../redux/recuperarSenha/actions";
import ExtratoRepasseExternoV2 from "../pages/extratoRepasseExternoV2";
import ExtratoRepasseExternoV2Impressao from "../pages/extratoRepasseExternoV2/imprimir";
import ProcedimentoCooperado from "../pages/procedimentoCooperado";
import { GcoopSessionConfig } from "../types/state.types";
import ProcedimentosPage from "../pages/procedimentoCooperado";
import DemonstrativoFinanceiro from "../pages/demonstrativoFinanceiro";
import DemonstrativoFinanceiroImpressao from "../pages/demonstrativoFinanceiro/imprimir";
import {
  ConfigsSet,
  getSession,
  getSessionConfig,
} from "../utils/session-helper";
import ListaDocumentos from "../pages/listaDocumentos";
import loginActions from "../redux/login/actions";

type RouteProps = {
  logged: boolean;
  routePermissions: GcoopSessionConfig;
};

const RouteConfig = ({ logged, routePermissions }: RouteProps) => {
  return (
    // <HashRouter>: cria uma # na navegação entre links
    // resolvendo o problema de refresh em produção
    <HashRouter>
      <AppRouter logged={logged} routePermissions={routePermissions} />
    </HashRouter>
  );
};

const AppRouter = ({ logged, routePermissions }: RouteProps) => {
  const [configs] = useState(getSessionConfig().Configuracoes);
  const [printing, setPriniting] = useState(
    window.location.href.endsWith("Imprimir")
  );
  const [permissions, setPermissions] = useState<{
    5000: boolean;
    5001: boolean;
    5002: boolean;
    5003: boolean;
    5004: boolean;
    5005: boolean;
    5007: boolean;
  }>({
    5000: false,
    5001: false,
    5002: false,
    5003: false,
    5004: false,
    5005: false,
    5007: false,
  });
  const history = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (routePermissions.Configuracoes) {
      const permissoes = {
        5000: false,
        5001: false,
        5002: false,
        5003: false,
        5004: false,
        5005: false,
        5007: false,
      };

      routePermissions.Configuracoes.forEach((perm) => {
        const newPermission: Record<number, boolean> = {};
        newPermission[perm.ID] = perm.Valor === "1";
        if (
          perm.ID === 5000 ||
          perm.ID === 5001 ||
          perm.ID === 5002 ||
          perm.ID === 5003 ||
          perm.ID === 5004 ||
          perm.ID === 5005 ||
          perm.ID === 5007
        )
          permissoes[perm.ID] = perm.Valor === "1";
      });
      setPermissions(permissoes);
    }
  }, [setPermissions, routePermissions.Configuracoes]);
  useEffect(() => {
    dispatch(recuperarSenhaActions.limparDados());
  }, [dispatch, history.pathname]);

  useEffect(() => {
    setPriniting(window.location.href.endsWith("Imprimir"));
  }, [history]);

  const navigate = useNavigate();

  useEffect(() => {
    const verifySessionInterval = setInterval(async () => {
      if (logged) {
        const session = await getSession();
        if (!session.logged) {
          dispatch(loginActions.logout());
          navigate("/");
        }
      }
    }, 30000);

    return () => clearInterval(verifySessionInterval);
  }, [logged, dispatch, navigate]);

  const initialPage = useCallback(() => {
    if (permissions[5000]) {
      return <EspelhoProducao />;
    }
    if (permissions[5001]) {
      return <RegistroBiometrico />;
    }
    if (permissions[5002]) {
      return <PrevisaoProducao />;
    }
    if (permissions[5003]) {
      return <ExtratoRepasseExterno />;
    }
    if (permissions[5004]) {
      return <ExtratoRepasse />;
    }
    if (permissions[5005]) {
      return <ImpostoRenda />;
    }
    if (permissions[5007]) {
      return <ExtratoRepasseExternoV2 />;
    }
    return <PaginaNaoEncontrada />;
  }, [permissions]);
  return (
    <Routes>
      <Route
        path={routes.home}
        element={<StaticContent logged={logged} printing={printing} />}
      >
        <Route path={routes.AmbienteDev} element={<AmbienteDev />} />
        {logged ? (
          <>
            <Route path="" element={initialPage()} />
            {configs &&
              configs.find((conf) => conf.ID === ConfigsSet.EspelhoProducao)
                ?.Valor === "1" && (
                <Route
                  path={routes.EspelhoProducao}
                  element={<EspelhoProducao />}
                />
              )}
            {configs &&
              configs.find((conf) => conf.ID === ConfigsSet.EspelhoProducao)
                ?.Valor === "1" && (
                <Route
                  path={routes.EspelhoProducaoImpressao}
                  element={<EspelhoProducaoImprimir />}
                />
              )}
            {configs &&
              configs.find((conf) => conf.ID === ConfigsSet.RegistroBiometrico)
                ?.Valor === "1" && (
                <Route
                  path={routes.RegistroBiometrico}
                  element={<RegistroBiometrico />}
                />
              )}
            {configs &&
              configs.find((conf) => conf.ID === ConfigsSet.PrevisaoProducao)
                ?.Valor === "1" && (
                <Route
                  path={routes.PrevisaoProducao}
                  element={<PrevisaoProducao />}
                />
              )}
            {configs &&
              configs.find(
                (conf) => conf.ID === ConfigsSet.ExtratoRepasseExterno
              )?.Valor === "1" && (
                <Route
                  path={routes.ExtratoRepasseExterno}
                  element={<ExtratoRepasseExterno />}
                />
              )}
            {configs &&
              configs.find(
                (conf) => conf.ID === ConfigsSet.ExtratoRepasseExterno
              )?.Valor === "1" && (
                <Route
                  path={routes.ExtratoRepasseExternoImpressao}
                  element={<ExtratoRepasseExternoImpressao />}
                />
              )}
            {configs &&
              configs.find((conf) => conf.ID === ConfigsSet.Procedimentos)
                ?.Valor === "1" && (
                <Route
                  path={routes.Procedimentos}
                  element={<ProcedimentoCooperado />}
                />
              )}
            {configs &&
              configs.find(
                (conf) => conf.ID === ConfigsSet.ExtratoRepasseExternoV2
              )?.Valor === "1" && (
                <Route
                  path={routes.ExtratoRepasseExternoV2}
                  element={<ExtratoRepasseExternoV2 />}
                />
              )}
            {configs &&
              configs.find(
                (conf) => conf.ID === ConfigsSet.ExtratoRepasseExternoV2
              )?.Valor === "1" && (
                <Route
                  path={routes.ExtratoRepasseExternoV2Impressao}
                  element={<ExtratoRepasseExternoV2Impressao />}
                />
              )}
            {configs &&
              configs.find((conf) => conf.ID === ConfigsSet.ExtratoRepasse)
                ?.Valor === "1" && (
                <Route
                  path={routes.ExtratoRepasse}
                  element={<ExtratoRepasse />}
                />
              )}
            {configs &&
              configs.find((conf) => conf.ID === ConfigsSet.ExtratoRepasse)
                ?.Valor === "1" && (
                <Route
                  path={routes.ExtratoRepasseImpressao}
                  element={<ExtratoRepasseImpressao />}
                />
              )}
            {configs &&
              configs.find(
                (conf) => conf.ID === ConfigsSet.DemonstrativoFinanceiro
              )?.Valor === "1" && (
                <Route
                  path={routes.DemonstrativoFinanceiro}
                  element={<DemonstrativoFinanceiro />}
                />
              )}
            {configs &&
              configs.find(
                (conf) => conf.ID === ConfigsSet.DemonstrativoFinanceiro
              )?.Valor === "1" && (
                <Route
                  path={routes.DemonstrativoFinanceiroImpressao}
                  element={<DemonstrativoFinanceiroImpressao />}
                />
              )}
            {configs &&
              configs.find((conf) => conf.ID === ConfigsSet.IR)?.Valor ===
                "1" && <Route path={routes.IR} element={<ImpostoRenda />} />}

            {configs &&
              configs.find((conf) => conf.ID === ConfigsSet.Procedimentos)
                ?.Valor === "1" && (
                <Route
                  path={routes.Procedimentos}
                  element={<ProcedimentosPage />}
                />
              )}
            {configs &&
              configs.find((conf) => conf.ID === ConfigsSet.Documentos)
                ?.Valor === "1" && (
                <Route path={routes.Documentos} element={<ListaDocumentos />} />
              )}
            <Route
              path={routes.RecuperacaoSenha}
              element={<RecuperarSenha />}
            />
            <Route path="*" element={<PaginaNaoEncontrada />} />
          </>
        ) : (
          <>
            <Route path="" element={<Login />} />
            <Route path="/Login" element={<Login />} />
            <Route
              path={routes.RecuperacaoSenha}
              element={<RecuperarSenha />}
            />
            {configs &&
              configs.find((conf) => conf.ID === ConfigsSet.PreCadastro)
                ?.Valor === "1" && (
                <Route path={routes.PreCadastro} element={<PreCadastro />} />
              )}
            <Route path="*" element={<PaginaNaoEncontrada />} />
          </>
        )}
      </Route>
    </Routes>
  );
};

export default RouteConfig;
